/** The required browser features. */
const requiredBrowserFeatures: readonly (keyof FeatureDetects)[] = [
  'history',
  'json',
  'localstorage',
  'postmessage',
  'urlsearchparams',
  'websockets',
];

/** The available required browser features. */
export type RequiredBrowserFeature = (typeof requiredBrowserFeatures)[number];

/** Represents the result of testing for browser features. */
type TestBrowserFeaturesResult = {
  /** The failed browser features. */
  readonly failed: readonly RequiredBrowserFeature[];
  /** The passed browser features. */
  readonly passed: readonly RequiredBrowserFeature[];
};

/** Test required browser features and returns which are passed and/or failed. */
export function testBrowserFeatures(): TestBrowserFeaturesResult {
  return requiredBrowserFeatures.reduce(
    ({ failed, passed }, feature) =>
      window.Modernizr[feature]
        ? { failed, passed: [...passed, feature] }
        : { failed: [...failed, feature], passed },
    { failed: [], passed: [] } as TestBrowserFeaturesResult,
  );
}
